<template>
  <div class="dashboard" @click="checkAgent()">
    <div class="sharePage" v-if="!currentWechat">
      <img class="sharePic" src="http://cdn.hongbaoxd.com/images/cf745696dd9aadd50df8f938853da54f.png" alt="">
      <img class="sharePic" src="http://cdn.hongbaoxd.com/images/4cbc899b6778e9204e2719b41d59b79a.png" alt="" />
      <button>立刻加入</button>
      <div class="popup-open-safari" :class="{'show': openSafariShow}">
        <div class="popup-content">
          <div><img src="//cdn.hongbaoxd.com/images/f6d9e1485fbd33127df61a814930977a.png" alt=""></div>
        </div>
      </div>
    </div>
    <div v-else>
      <!--头部信息-->
      <div class="header-block">
        <NavBtn
          :img-url="avatar_src"
          :on-click="checkAgent"
        />
        <section class="header">
          <div class="logo"><img src="//cdn.hongbaoxd.com/images/a6e1f6b38f3fd38d0f8a50d1965dd58b.png" alt="" /></div>
          <div class="ball-bg">
            <img src="//cdn.hongbaoxd.com/images/07b7d1a839d06dfc6a4d90a3a0b5f7fa.png" style="height: 128px;" alt="" />
          </div>
        </section>

        <section class="main-info">

          <div class="team triple-row">
            <div class="wallet">
              <div>我的余额</div>
              <div>
                <span>{{balance}}</span><span>元</span>
              </div>
              <div class="btn-small">提现</div>
            </div>

            <div class="member">
              <div>我的徒弟</div>
              <div>
                <span>{{team_member_num}}</span><span>人</span>
              </div>
              <div class="btn-small">邀请</div>
            </div>

            <div class="money">
              <div>收徒奖励</div>
              <div>
                <span>{{team_money}}</span><span>元</span>
              </div>

              <div class="btn-small reward" v-if="team_money > 0">领取</div>
              <div class="btn-small disabled" v-if="team_money <= 0">领取</div>
            </div>
          </div>
        </section>

        <!-- <ShareDialog ref="share" /> -->
        <!-- <RewardApprenticeDialog ref="reward" :amount ='amount'/> -->
      </div>

      <!--进行中-->
      <div class="block">
        <div class="title">
          <img src="//cdn.hongbaoxd.com/images/7a6376620cc249cd275dcd3d10cec1f2.png" alt="" height="12">
          <span>限量试玩</span>
          <img class="horizon-reverse" src="//cdn.hongbaoxd.com/images/7a6376620cc249cd275dcd3d10cec1f2.png" alt="" height="12">
        </div>

        <div class="task row" v-for="(task, index) in running" :key="index">
          <img :src="task.icon" alt="">
          <span class="desc" v-if="task.status == 2">进行中…</span>
          <span class="desc" v-else-if="task.remain_num > 0">还有 {{task.remain_num}}+ 份</span>
          <span class="desc disabled" v-else>已抢完</span>
          <span class="unit" :class="{'disabled': task.remain_num <= 0}">元奖励</span>
          <span class="reward" :class="{'disabled': task.remain_num <= 0}">1.5</span>
        </div>
        <InstallDialog ref="install" />
        <!--<OpenSafariDialog ref="opensf" />-->
      </div>

      <!--即将开始-->
      <div class="block" style="margin-bottom: 40px">
        <div class="title">
          <img src="//cdn.hongbaoxd.com/images/7a6376620cc249cd275dcd3d10cec1f2.png" alt="" height="12">
          <span>尚未开始</span>
          <img class="horizon-reverse" src="//cdn.hongbaoxd.com/images/7a6376620cc249cd275dcd3d10cec1f2.png" alt="" height="12">
        </div>

        <div class="task row" v-for="(task, index) in upcoming" :key="index">
          <img src="//cdn.hongbaoxd.com/images/3614db08e24cc4d56b96435d64f95cbd.png" alt="">
          <span class="desc">{{task.start_at}} 开抢</span>
          <span class="unit">元奖励</span>
          <span class="reward">{{task.reward}}</span>
        </div>
      </div>
      <div class="bottom-logo">
        <!-- <img src="//cdn.hongbaoxd.com/images/dcad39efba024a1eeae3e6336f2863fc.png" alt=""> -->
      </div>
    </div>
  </div>
</template>
<style lang='scss' scoped>
  @import '../../dashboard/header';
  @import '../../dashboard/block';
  .nav-btn {
    top: 26px !important;
  }
  .header-block {
    /* padding-top: 40px; */
    padding-top: 72px;
  }
  @media only screen and (device-height: 812px) {
    .nav-btn {
      top: 35px !important;
    }
    .header-block {
      /* padding-top: 30px; */
      padding-top: 62px;
    }
  }

// installAuth
  #auth{
      .nav-btn {
        top: 36px !important;
      }
      .header-block {
        padding-top: 69px;
      }
      @media only screen and (device-height: 812px) {
        .nav-btn {
          top: 45px !important;
        }
        .header-block {
          /* padding-top: 76px; */
          padding-top: 59px;
        }
      }
  }

  .dashboard {
    background-color: #3A4E92;
    padding-bottom: 20px;

    .bottom-logo {
      text-align: center;
      height: 18px;

      img {
        height: 18px;
      }
    }

    .popup-open-safari {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .75);
      z-index: 20;
      opacity: 0;
      transition: 0.3s opacity;

      &.show {
        z-index: 999;
        opacity: 1;
      }

      .popup-content {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 222px;
        height: 120px;

        img {
          width: 222px;
          height: 120px;
        }
      }
    }

    .sharePage{
      text-align: center;
      .sharePic{
        width: 100%;
        &:first-child{
          width: 53%;
          margin: 40px auto;
        }
      }
      button {
        width: 53%;
        border:none;
        padding: 10px;
        font-size: 20px;
        color: #3a3a3a;
        margin-top: 40px;
        border-radius: 40px;
        background-color: #fff;
      }
    }
  }
</style>
<script>
import { mapState, mapActions } from 'vuex'
import InstallDialog from './popups/InstallDialog'
import OpenSafariDialog from '@/components/OpenSafariDialog'
import { URI_ASSISTALIVE } from '@/store/modules/shoutu/type'
export default {
  name: 'ShouTu',
  components: {
    InstallDialog,
    OpenSafariDialog
  },
  props: {
    msg: String
  },
  computed: {
    ...mapState({
      uid: state => state.shoutu.uid,
      idfa: state => state.shoutu.idfa,
      avatar: state => state.shoutu.avatar,
      balance: state => state.shoutu.balance,
      upcoming: state => state.shoutu.upcoming,
      running: state => state.shoutu.running,
      team_money: state => state.shoutu.team_money,
      team_member_num: state => state.shoutu.team_member_num
    }),
    'avatar_src': function () {
      return this.avatar === ''
        ? '//cdn.hongbaoxd.com/images/9fe384e3a5114f73814e2d212515b26d.png'
        : this.avatar
    }
  },
  data () {
    return {
      currentWechat: false,
      openSafariShow: false,
      agent: window.navigator.userAgent.toLocaleLowerCase()
    }
  },
  created () {
    if (this.$route.path !== '/outland/') {
      this.currentWechat = true
    } else {
      if (this.isWeixin() || this.isQQ()) {
        this.currentWechat = false
      }
      if (this.isSafari()) {
        let host = location.host
        if (process.env.VUE_APP_HOST.indexOf(host)) {
          this.currentWechat = true
        } else {
          window.location.href = `http://${host}${location.pathname}${location.search}`
        }
      }
    }
  },

  mounted () {
    this.getAlive()
  },

  methods: {
    ...mapActions({
      getAlive: URI_ASSISTALIVE
    }),

    checkAgent () {
      if (this.$route.path === '/outland/') {
        if (this.openSafariShow) {
          this.openSafariShow = false
          return
        }
        if (this.isSafari()) {
          this.$refs.install.show()
        } else if (this.isWeixin() || this.isQQ()) {
          // this.$refs.opensf.show()
          this.openSafariShow = true
        } else {
          window.location.href = 'http://baidu.com'
        }
      }
    },

    isIPhone () {
      return this.ua_match(/iPhone/i, 'iphone')
    },

    isWeixin () {
      return this.ua_match(/MicroMessenger/i, 'micromessenger')
    },

    isQQ () {
      return this.ua_match(/QQ\//i, 'qq/')
    },

    isAndroid () {
      return this.ua_match(/Android/i, 'android')
    },

    isSafari () {
      return this.ua_match(/Safari/i, 'safari')
    },

    ua_match (re, phrase) {
      // re: UA中的正则关键词, phrase: 最终匹配出的短语
      let matches = this.agent.match(re)
      if (matches && matches[0] === phrase) {
        return true
      }
      return false
    }
  }
}
</script>
